import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBlackHole: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBlackHole"><Path d="M21 12C21 16.9706 16.9706 21 12 21C9.40041 21 7.05824 19.8978 5.41529 18.1353L3 20.2286V12C3 7.02944 7.02944 3 12 3C14.4908 3 16.7453 4.01184 18.3748 5.64689L21 3.61588V12Z" stroke="currentColor"/><Circle cx="12" cy="12" r="4" stroke="currentColor" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBlackHole;
